// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import { Box } from 'grommet';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';
import { setApiUrls } from './actions/api/api-constants';

const spinner = (
  <Box align="center" pad="xsmall">
    <LoadingSpinner size="medium" />
  </Box>
);

export default function ApiRootUpdater({ children }) {
  // eslint-disable-next-line max-len
  const COM_API_ROOT_URL = `${window.indigo.REACT_APP_COM_CLOUDFRONT_ROOT_URL}${window.indigo.REACT_APP_COM_API_PATH}`;
  setApiUrls(COM_API_ROOT_URL);

  return children;
}
